import type { Database } from '@backend/db'
import { createClient } from '@supabase/supabase-js'
import { getEnvironmentConfig } from '@/lib/environment'

const config = getEnvironmentConfig()

const PROJECT_ID = 'cnrcisrkvupfprulxtkh'
const PUBLIC_STORAGE_KEY = `sb-public-${PROJECT_ID}`
const AUTHPROXY_STORAGE_KEY = `sb-clerk-${PROJECT_ID}`

export const createSupabaseClient = (
  getToken?: () => Promise<string | null>
) => {
  return createClient<Database, 'public'>(
    config.supabaseUrl,
    config.supabasePublishableKey,
    {
      auth: {
        storage: localStorage,
        storageKey: getToken ? AUTHPROXY_STORAGE_KEY : PUBLIC_STORAGE_KEY,
        persistSession: false, // Disable built-in auth as we use Clerk
        autoRefreshToken: false,
      },
      global: {
        fetch: async (
          url: string | URL | Request,
          options: RequestInit = {}
        ) => {
          if (getToken) {
            try {
              const token = await getToken()
              if (token) {
                const headers = new Headers(options.headers)
                headers.set('Authorization', `Bearer ${token}`)
                options.headers = headers
              }
            } catch (error) {
              console.error('Error getting token:', error)
            }
          }
          return fetch(url, options)
        },
      },
      db: {
        schema: 'public',
      },
    }
  )
}

// Default client for non-authenticated requests only
export const supabase = createSupabaseClient()
